import '../styles/pappasrw.css';

import { createApp } from 'vue';

import PappasLeadsForm from '@pappas/leads-form';
// import PappasLeadsForm from '../../../pappas-leads-form/src/index.js';
import PappasReservationForm from '@pappas/reservation-form';
// import PappasReservationForm from '../../../pappas-reservation-form/src/js/index.js';

import { rootComponents } from './components/index.js';
import LogoText from '../images/logo-text.svg';
import LogoBanner from '../images/logo-banner.svg';
import LogoBannerExt from '../images/logo-banner-ext.svg';
import RestaurantsList from './components/RestaurantsList/RestaurantsList.vue';
import DropdownArrowIcon from '../images/icons/dropdown-arrow.svg';
import CheckboxInput from './components/Forms/CheckboxInput.vue';
import RadioInput from './components/Forms/RadioInput.vue';

import { createPinia } from 'pinia';
import { createRouter, createWebHistory } from 'vue-router';
import SubmitButton from './components/Forms/SubmitButton.vue';

if (import.meta.hot) {
    import.meta.hot.accept();
}

const routes = [
    { path: '/', component: RestaurantsList },
    { path: '/restaurants/:page(\\d+)?', component: RestaurantsList },
    { path: '/restaurants/:concept/:page(\\d+)?', component: RestaurantsList },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

const vSelectProps = {
    appendToBody: true,
    components: { OpenIndicator: DropdownArrowIcon },
};

const pinia = createPinia();
const app = createApp();

app.use(pinia);
app.use(router);

app.use(PappasReservationForm, {
    vSelectProps,
    inputComponents: { checkbox: CheckboxInput },
});

app.use(PappasLeadsForm, { 
    vSelectProps,
    inputComponents: { checkbox: CheckboxInput, radio: RadioInput, submitButton: SubmitButton },
});

for (const [key, component] of Object.entries({ ...rootComponents })) {
    app.component(key, component);
}

app.component('LogoText', LogoText);
app.component('LogoBanner', LogoBanner);
app.component('LogoBannerExt', LogoBannerExt);

app.mount('#pappasrw-app');
